<template>
  <transition name="fade">
    <div v-if="isCookiesPopupVisible" class="cookies-popup d-flex flex-column justify-center align-center">
      <p class="cookies-popup__text">Мы используем файлы cookie для улучшения работы сайта. Оставаясь на сайте, вы соглашаетесь с обработкой файлов cookie. Запретить сохранение можно в настройках вашего браузера.</p>
      <btn-primary @click="onAcceptButtonClick">Принять</btn-primary>
    </div>
  </transition>
</template>

<script>
import BtnPrimary from "@/components/btn-primary.vue";

export default {
  name: 'cookies-popup',
  components: {BtnPrimary},
  data() {
    return {
      isCookiesPopupVisible: false,
    }
  },
  methods: {
    onAcceptButtonClick() {
      localStorage.setItem('isCookiesAccepted', '1');
      this.isCookiesPopupVisible = false;
    }
  },
  mounted() {
    const isAccepted = localStorage.getItem('isCookiesAccepted');

    if (isAccepted) return;
    this.isCookiesPopupVisible = true;
  }
}
</script>

<style lang="scss">
.cookies-popup {
  position: fixed;
  right: 15px;
  left: 15px;
  bottom: 15px;
  padding: 15px;
  gap: 19px;
  background: $white;
  border: 1px solid $gray-light;
  z-index: $z-highest;

  @include up($md) {
    right: 15px;
    left: unset;
    bottom: 15px;
    width: 400px;
    padding: 25px;
    gap: 20px;
  }
}
</style>